import { makeStyles } from "@material-ui/core/styles";
const theme = (props) => {
  const styles = makeStyles(theme => ({
    container: {
      padding: 20,
      '& .title': {
        color: '#374151',
        fontWeight: 500,
        fontSize: 20,
        marginBottom: 20,
      },
      '& .label': {
        color: '#989898',
        fontWeight: 500,
        fontSize: 14,
        marginBottom: 20,
      },
      '& .text': {
        color: '#989898',
        fontWeight: 300,
        fontSize: 14,
        marginBottom: 20,
      }
    },

    '@media (max-width: 600px)': {
      container: {
        padding: 14,
        '& .title': {
          fontSize: 'var(--mobile-title-size)',
          lineHeight: 'var(--lh-title)',
          marginBottom: 12,
          color: 'var(--text-strong)!important',
        },
        '& .label': {
          marginBottom: 4,
          fontSize: 'var(--mobile-label-size)',
          letterSpacing: 0.35,
          color: 'var(--text-muted)',
        },
        '& .text': {
          fontWeight: 400,
          marginBottom: 6,
          color: 'var(--text-body)',
          fontSize: 'var(--mobile-body-size)',
          lineHeight: 'var(--lh-body)',
          whiteSpace: 'normal',
          overflowWrap: 'anywhere',
          wordBreak: 'break-word',
          '& .text a': {
            whiteSpace: 'normal',
            overflowWrap: 'anywhere',
            wordBreak: 'break-word',
          },
        },
      }
    }

  }));
  return styles();
}
export default theme;

